import { useState } from 'react';

import { useLazyQuery } from '@apollo/client/react';

import type { EmailSenderFragment } from '@graphql/__generated__/graphql';

import { GET_SENDER_DETAILS } from './queries';

export const useEmailSender = (initialSender: EmailSenderFragment | null) => {
  const [getSenderDetails] = useLazyQuery(GET_SENDER_DETAILS);
  const [sender, setSender] = useState<EmailSenderFragment | null>(
    initialSender,
  );

  const selectSender = async (senderId: string | null | undefined) => {
    if (senderId == null) {
      setSender(null);
      return;
    }

    const result = await getSenderDetails({
      variables: { id: senderId },
    });
    setSender(result.data?.users_by_pk ?? null);
  };

  return { sender, selectSender };
};
